export default {
  title: 'Air Rate Management',
  createTitle: 'Create Air Rate',
  editTitle: 'Edit Air Rate',
  viewTitle: 'Air Rate Detail',
  copyTitle: 'Copy Air Rate',
  filters: {
    priceNo: 'Rate No.',
    source: 'Source',
    airline: 'Airline',
    pol: 'Origin Airport',
    pod: 'Destination Airport',
    status: 'Status',
    specialPriceStatus: 'Special Price Status',
    validity: 'Validity',
    originCountry: 'Origin Country',
    destinationCountry: 'Destination Country',
    originCity: 'Origin City',
    destinationCity: 'Destination City',
    supplier: 'Supplier',
    office: 'Office',
    cargoType: 'Cargo Type',
    directFlag: 'Direct/Transit',
    transferPort: 'Transit Airport',
    lane: 'Lane',
    validPeriod: 'Validity'
  },
  placeholders: {
    priceNo: 'Enter rate number',
    source: 'Select source',
    company: 'Select company',
    supplier: 'Select supplier',
    cargoType: 'Select cargo type',
    airline: 'Select airline',
    pol: 'Select origin airport',
    pod: 'Select destination airport',
    validPeriod: 'Select validity period',
    status: 'Select status',
    validity: 'Select validity',
    remark: 'e.g. cutoff time, requirements',
    transferPort: 'Select transit airport',
    originCountry: 'Select origin country',
    destinationCountry: 'Select destination country',
    originCity: 'Select origin city',
    destinationCity: 'Select destination city',
    directFlag: 'Select direct/transit',
    lane: 'Select lane',
    eta: 'Select ETA',
    etd: 'Select ETD',
    voyageHours: 'Enter transit hours (integer)',
    serviceType: 'Select service type',
    onePrice: 'Select one price',
    receivingInstructions: 'Enter receiving instructions',
    flightDepartureTime: 'Select departure time',
    flightArrivalTime: 'Select arrival time',
    selectDepartureWeekdays: 'Select departure schedule'
  },
  validation: {
    voyageHoursInteger: 'Transit time must be a non-negative integer'
  },
  columns: {
    priceNo: 'Rate No.',
    source: 'Source',
    airline: 'Airline',
    supplier: 'Supplier',
    pol: 'POL',
    pod: 'POD',
    nPrice: 'N Price(<45KG)',
    normal: 'N Price(<45KG)',
    p45: '+45KG',
    p100: '+100KG',
    p300: '+300KG',
    p500: '+500KG',
    p1000: '+1000KG',
    p2000: '+2000KG',
    validPeriod: 'Validity',
    validity: 'Validity',
    status: 'Status',
    specialPriceStatus: 'Special Price Status',
    actions: 'Actions',
    feeName: 'Fee Name',
    type: 'Fee Type',
    price: 'Price',
    unit: 'Unit',
    remark: 'Remark',
    minCharge: 'Min Charge',
    maxCharge: 'Max Charge',
    feeSource: 'Fee Source'
  },
  fields: {
    priceNo: 'Rate No.',
    source: 'Source',
    relationNo: 'Relation No.',
    company: 'Company',
    supplier: 'Supplier',
    cargoType: 'Cargo Type',
    contractNo: 'Contract No.',
    validPeriod: 'Validity',
    airline: 'Airline',
    flightNo: 'Flight No.',
    pol: 'POL',
    pod: 'POD',
    pickupAddr: 'Pickup Address',
    routeLevel: 'Route Level',
    spaceStatus: 'Space Status',
    packageType: 'Package Type',
    directFlag: 'Direct/Transit',
    transitTime: 'Transit Time (Hrs)',
    currency: 'Currency',
    volWeightRatio: 'Vol-Weight Ratio',
    payTerm: 'Pay Term',
    densityLevel: 'Density Level',
    remark: 'Remark',
    specialCargoRemark: 'Special Cargo Remark',
    transportTerm: 'Transport Mode',
    tradeTerm: 'Trade Term',
    specialPriceStatus: 'Special Price Status',
    transferPort: 'Transit Airport',
    etd: 'ETD',
    eta: 'ETA',
    beginDate: 'Effective Date',
    endDate: 'Expiry Date',
    viewRule: 'View Rule',
    systemRule: 'System Rule',
    userCreated: 'User Created',
    serviceType: 'Service Type',
    onePrice: 'One Price',
    receivingInstructions: 'Receiving Instructions',
    flightDepartureTime: 'Departure Time',
    flightArrivalTime: 'Arrival Time',
    departureWeekdays: 'Departure Schedule',
    costPrice: 'Cost'
  },
  enums: {
    source: {
      '1': 'Manual',
      '2': 'Excel Import',
      '3': 'Inquiry',
      '4': 'Tender'
    },
    status: {
      1: 'Draft',
      2: 'Normal',
      3: 'Expired',
      4: 'Offline',
      5: 'Disabled',
      6: 'Pending'
    },
    specialPriceStatus: {
      '1': 'Special price not allowed',
      '2': 'Special price allowed',
      '3': 'Special price'
    },
    cargoTypes: {
      '1': 'General',
      '2': 'Dangerous',
      '3': 'Cold',
      '4': 'Special',
      '5': 'Steel Coil',
      '6': 'Liquid',
      '7': 'Chemical',
      '8': 'Textile'
    },
    routeLevels: {
      '1': 'Express',
      '2': 'Standard',
      '3': 'Economy'
    },
    packageTypes: {
      '1': 'Carton',
      '2': 'Wooden',
      '3': 'Pallet',
      '4': 'Bulk'
    },
    rateTypes: {
      '1': 'Level 1 Agent',
      '2': 'Level 2 Agent',
      '3': 'E-commerce'
    },
    offices: {
      '1': 'Shanghai',
      '2': 'Shenzhen',
      '3': 'Guangzhou'
    },
    directFlags: {
      direct: 'Direct',
      transit: 'Transit'
    },
    payTerms: {
      prepaid: 'Prepaid',
      collect: 'Collect'
    },
    surchargeTypes: {
      AIR: 'Mainline Surcharge',
      POR: 'Origin Surcharge',
      FND: 'Destination Surcharge'
    },
    units: {
      KG: 'KG',
      ticket: 'Ticket'
    },
    surchargeNames: {
      fsc: 'Fuel Surcharge',
      ssc: 'Security Surcharge',
      awb: 'AWB Fee',
      myc: 'Fuel War Surcharge',
      doc: 'Documentation Fee',
      hdl: 'Handling Fee'
    },
    serviceTypes: {
      CONSOL: 'Consolidation',
      FULL_PALLET: 'Full Pallet',
      BLOCK_SPACE: 'Block Space',
      FULL_CHARTER: 'Full Charter'
    }
  },
  sections: {
    basicInfo: 'Basic Info',
    flightInfo: 'Flight Info',
    feeDetail: 'Fee Detail',
    freight: 'Freight',
    surcharge: 'Surcharges',
    remark: 'Remark',
    serviceAndOther: 'Logistics Params & Remark'
  },
  actions: {
    back: 'Back',
    add: 'New Air Rate',
    edit: 'Edit',
    view: 'View',
    copy: 'Copy',
    saveDraft: 'Save Draft',
    publish: 'Publish',
    import: 'Import',
    export: 'Export',
    downloadTemplate: 'Template',
    aiRecognition: 'AI Recognition',
    batchOperations: 'Batch Operations',
    batchPublish: 'Batch Publish',
    batchOffline: 'Batch Offline',
    batchPriceChange: 'Batch Price Change',
    batchTimeChange: 'Batch Time Change',
    batchDelete: 'Batch Delete',
    more: 'More',
    delete: 'Delete',
    addSurcharge: 'Add Surcharge',
    offline: 'Offline',
    cancel: 'Cancel',
    confirm: 'Confirm',
    reset: 'Reset'
  },
  messages: {
    fetchFailed: 'Fetch failed',
    saveSuccess: 'Draft saved',
    publishSuccess: 'Successfully published {count} rates',
    deleteSuccess: 'Successfully deleted {count} rates',
    offlineSuccess: 'Successfully offlined {count} rates',
    deleteConfirm: 'Delete the selected {count} rates? This cannot be undone.',
    downloadingTemplate: 'Downloading',
    uploading: 'Uploading...',
    validating: 'Validating...',
    matching: 'Matching...',
    saving: 'Saving...',
    generatingErrorReport: 'Generating report...',
    batchPublishSuccess: 'Batch published {count} records',
    onlyDraftCanPublish: 'Only draft and pending-import rates can be published. Selection includes: {status}',
    onlyNormalCanOffline: 'Only published rates can be offlined. Selection includes: {status}',
    onlyDraftCanDelete: 'Only draft rates can be deleted. Selection includes: {status}',
    offlineConfirm: 'Offline the selected {count} rates?',
    noSelection: 'Please select at least one record',
    batchUpdateSuccess: 'Batch update success',
    selectValidity: 'Please select validity period',
    onlyDraftCanModify: 'Only draft status can be modified',
    recordsToModify: 'Rates to be modified',
    selectedCount: '{count} items selected',
    comingSoon: 'Coming Soon',
    exportFilename: 'Air Rates Export',
    templateDownloadFailed: 'Template download failed'
  },
  batch: {
    timeChange: {
      currentEtd: 'Current ETD',
      currentEta: 'Current ETA',
      currentValidPeriod: 'Current Validity'
    }
  },
  aiRecognition: {
    title: 'AI Smart Recognition',
    uploadTitle: 'Upload Rate File',
    uploadDesc: 'Click or drag file here, system will automatically recognize content and extract rate info',
    processing: 'AI Recognizing...',
    processingDesc: 'Please wait, AI is analyzing your rate file...',
    success: 'Recognized successfully!',
    successDesc: 'Rate info successfully recognized and imported',
    error: 'Recognition failed',
    errorDesc: 'File recognition failed, please check format or re-upload',
    retry: 'Re-upload',
    aiDescription: 'AI Recognition Info',
    aiFeatures: [
      'AI will automatically recognize ports, carriers, prices etc.',
      'Supports multiple formats and complex table structures',
      'Background task will be created after identification',
      'Please ensure uploaded files are clear and readable'
    ],
    successTitle: 'AI task submitted',
    successDescription: 'Task is running in background. Please check progress in <strong>System Settings - Task Management</strong>.',
    goToTaskManagement: 'Go to Tasks',
    close: 'Close',
    uploadFile: 'Upload {type} file',
    clickOrDrag: 'Click or drag file here to upload',
    supportedFormats: 'Formats: PDF, Excel, Word, Image etc.',
    selectFile: 'Select File',
    aiParsing: 'AI Parsing...',
    aiParsingTip: 'AI is parsing document, please wait...'
  },
  form: {
    sections: {
      basicInfo: 'Basic Info',
      routeInfo: 'Route Info',
      validityInfo: 'Validity Info',
      weightPrice: 'Weight Segment Price (USD/KG)',
      remark: 'Remark'
    },
    labels: {
      airline: 'Airline',
      supplier: 'Supplier',
      cargoType: 'Cargo Type',
      pol: 'Origin Airport',
      pod: 'Destination Airport',
      directFlag: 'Direct/Transit',
      validityDate: 'Validity',
      flightNo: 'Flight No.',
      minCharge: 'M (Min Charge)',
      nPrice: 'N (<45KG)',
      price45: '+45KG',
      price100: '+100KG',
      price300: '+300KG',
      price500: '+500KG',
      price1000: '+1000KG',
      specialCargoRemark: 'Special Cargo Remark',
      remark: 'Remark'
    },
    placeholders: {
      airline: 'Select airline',
      supplier: 'Select supplier',
      cargoType: 'Select cargo type',
      pol: 'Select origin airport',
      pod: 'Select destination airport',
      flightNo: 'Enter flight no.',
      minCharge: 'Min charge amount',
      nPrice: 'Unit price below 45KG',
      price45: 'Unit price 45KG and above',
      price100: 'Unit price 100KG and above',
      price300: 'Unit price 300KG and above',
      price500: 'Unit price 500KG and above',
      price1000: 'Unit price 1000KG and above',
      specialCargoRemark: 'Enter special cargo remark, e.g. battery, dangerous goods',
      remark: 'Enter additional notes'
    },
    options: {
      general: 'General',
      dangerous: 'Dangerous',
      cold: 'Cold Chain',
      oversize: 'Oversize',
      direct: 'Direct',
      transit: 'Transit'
    },
    validation: {
      airline: 'Please select airline',
      supplier: 'Please select supplier',
      cargoType: 'Please select cargo type',
      pol: 'Please select origin airport',
      pod: 'Please select destination airport',
      validityDate: 'Please select validity',
      nPrice: 'Please enter N price'
    },
    airlines: {
      CX: 'Cathay Pacific (CX)',
      CA: 'Air China (CA)',
      MU: 'China Eastern (MU)',
      CZ: 'China Southern (CZ)',
      HU: 'Hainan Airlines (HU)'
    },
    airports: {
      HKG: 'Hong Kong Airport (HKG)',
      PVG: 'Shanghai Pudong Airport (PVG)',
      PEK: 'Beijing Capital Airport (PEK)',
      LAX: 'Los Angeles Airport (LAX)',
      FRA: 'Frankfurt Airport (FRA)',
      NRT: 'Tokyo Narita Airport (NRT)'
    }
  }
}
